export const PaymentAr = {
  "Paiements": "المدفوعات",
}